// extracted by mini-css-extract-plugin
module.exports = {"article":"Layout_article__D53GD","oldCss":"Layout_oldCss__avNSm","colMainContentMaxWidth":"Layout_colMainContentMaxWidth__1IlfJ"};